(function () {
  'use strict';

  const clean = url => String(url || '').split(/[?#]/, 1)[0];
  const anchorFor = (anchors, url) => {
    const wanted = clean(url);
    return (Array.isArray(anchors) ? anchors : []).find(anchor => clean(anchor && anchor.action_url) === wanted) || null;
  };
  const fallback = (profile, originalUrl, reason) => ({
    url: originalUrl,
    originalUrl,
    anchorSet: Array.isArray(profile && profile.head800) ? profile.head800 : [],
    anchor: anchorFor(profile && profile.head800, originalUrl),
    resolution: 800,
    fallbackReason: reason
  });

  const resolve = (profile, originalUrl, mobile) => {
    if (!mobile || document.documentElement.classList.contains('desktop-agent')) return fallback(profile, originalUrl, 'desktop');
    const source = String(originalUrl || '');
    if (!clean(source).includes('/Codexwebp_800/')) return fallback(profile, source, 'unsupported-path');
    const url = source.replace('/Codexwebp_800/', '/Codexwebp_300/');
    const anchor = anchorFor(profile && profile.head300, url);
    if (!anchor) return fallback(profile, source, 'missing-head300');
    return {
      url,
      originalUrl: source,
      anchorSet: profile.head300,
      anchor,
      resolution: 300,
      fallbackReason: ''
    };
  };

  window.BeanAgentMediaVariant = Object.freeze({ resolve, anchorFor });
})();



//////////////////
// WEBPACK FOOTER
// ./homepage-source/bean-agent-media-variant.js
// module id = wT7R
// module chunks = 1